"use client";

import { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Tabs,
  Tab,
  Divider,
  Chip,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  Build as BuildIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  CalendarToday as CalendarTodayIcon,
  Person as PersonIcon,
  Visibility as VisibilityIcon,
  Print as PrintIcon,
  Close as CloseIcon,
  Info as InfoIcon,
  Image as ImageIcon,
  Timeline as TimelineIcon,
  Description as DescriptionIcon,
} from "@mui/icons-material";
import {useApi} from "../../../hooks/useApi"
import {ENDPOINTS} from "../../../config/endpoints"
import { UrlApi } from "../../../../../services/apirest";
import moment from "moment";
import axios from "axios";
import { calcularVencimientoPorPeriodo } from "../../../utils/calcvencimiento";
export function EquipmentHistory({ equipment, open, onClose }) {
  const { get ,loading ,error} = useApi();
  const [tabValue, setTabValue] = useState(0);
  const [selectedMaintenance, setSelectedMaintenance] = useState(null);
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleOpenDetail = (maintenance) => {
    setSelectedMaintenance(maintenance);
    setDetailDialogOpen(true);
  };

  const handleCloseDetail = () => {
    setDetailDialogOpen(false);
  };

  //OBTENER HISTORIAL DE MANTENIMIENTOS Y ORDEDES DE TRABAJO
  const [maintenanceHistory, setMaintenanceHistory] = useState([]);
  const [workOrdersHistory, setWorkOrdersHistory] = useState([]);
  const getMaintenanceHistory =async () => {
    try {

      const {data} = await axios.get(`${UrlApi}${ENDPOINTS.CORRECTIVOS.BASE}${ENDPOINTS.CORRECTIVOS.HISTORIAL}/${equipment.id}`)
     
      if (data) {
        setMaintenanceHistory(data);
      }
    } catch (error) {
      console.error(error.message);
    }
  }
  const getWorkOrdersHistory = async() => {
    try {
      const {data} = await axios.get(`${UrlApi}${ENDPOINTS.OTS.BASE}${ENDPOINTS.OTS.HISTORIAL}/${equipment.id}`)
       const ordenConVencimiento = data?.map(orden => {
                      const baseFecha = orden.fecha_realizado;
                      const fechaVencimiento = calcularVencimientoPorPeriodo(baseFecha, orden);
              
                      return {
                        ...orden,
                        vencimiento: fechaVencimiento.format('YYYY-MM-DD'),
                       
                      };
                    });
      if (data) {
        setWorkOrdersHistory(ordenConVencimiento)
      }
    } catch (error) {
      console.error(error.message)
    }
  }
 useEffect(() => {
  getMaintenanceHistory();
    getWorkOrdersHistory();
  }, [equipment.id]);




  // Datos de ejemplo para órdenes de trabajo
  
  const renderMaintenanceStatusChip = (status) => {
    switch (status) {
      case 1:
        return <Chip label="Completado" color="success" size="small" />;
      case 2:
        return <Chip label="En Progreso" color="primary" size="small" />;
      case 0:
        return <Chip label="Pendiente" color="warning" size="small" />;
      default:
        return null;
    }
  };
  const renderOrderStatusChip = (status) => {
    switch (status) {
      case "realizado":
        return <Chip label="Completado" color="success" size="small" />;
      case "en_progreso":
        return <Chip label="En Progreso" color="primary" size="small" />;
      case "pendiente":
        return <Chip label="Preparada" color="warning" size="small" />;
      default:
        return null;
    }
  };

  const renderMaintenanceTypeChip = (type) => {
    switch (type) {
      case "preventive":
        return <Chip label="Preventivo" color="info" size="small" />;
      case "corrective":
        return <Chip label="Correctivo" color="error" size="small" />;
      default:
        return null;
    }
  };

  const renderPriorityChip = (priority) => {
    switch (priority) {
      case "high":
        return <Chip label="Alta" color="warning" size="small" />;
      case "medium":
        return <Chip label="Media" color="info" size="small" />;
      case "low":
        return <Chip label="Baja" color="success" size="small" />;
      case "critical":
        return <Chip label="Crítica" color="error" size="small" />;
      default:
        return null;
    }
  };

console.log("workOrdersHistory", workOrdersHistory);

  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Historial del Equipo</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            mb: 3,
            p: 2,
            bgcolor: "background.paper",
            borderRadius: 1,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography variant="h5" gutterBottom>
            {equipment?.equipo} ({equipment?.id})
          </Typography>
          <Box sx={{ mt: 0.5, mb: 0.5 }}>
            <Typography variant="body2" color="text.secondary">
              {equipment?.serie_equipo}
            </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Typography variant="body2" color="text.secondary">
                Sección:
              </Typography>
              <Typography variant="body1">{equipment?.sector}</Typography>
            </Grid>
           <Grid item xs={12} md={4}>
              <Typography variant="body2" color="text.secondary">
                Estado Actual:
              </Typography>
              <Box sx={{ mt: 0.5 }}>
                {equipment?.estado === "en servicio" ? (
                  <Chip
                    icon={<CheckCircleIcon />}
                    label="En Servicio"
                    color="success"
                    size="small"
                  />
                ) : equipment?.estado === "Fuera de Servicio" ? (
                  <Chip label="Fuera de Servicio" color="primary" size="small" />
                ) : (
                  <Chip
                    icon={<WarningIcon />}
                    label="En Mantenimiento"
                    color="warning"
                    size="small"
                  />
                )}
              </Box>
            </Grid> 
            <Grid item xs={12} md={4}>
              <Typography variant="body2" color="text.secondary">
                Zona:
              </Typography>
              <Typography variant="body1">
                {equipment?.zona}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="equipment history tabs"
            >
              <Tab
                icon={<BuildIcon />}
                iconPosition="start"
                label="Correctivos"
              />
              <Tab
                icon={<AssignmentIcon />}
                iconPosition="start"
                label="Órdenes de Trabajo"
              />
            {/*   <Tab
                icon={<TimelineIcon />}
                iconPosition="start"
                label="Cronología"
              /> */}
            </Tabs>
          </Box>

          {/* Tab de Mantenimientos */}
          {tabValue === 0 && (
            <Box sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Historial de Mantenimientos
              </Typography>

              {maintenanceHistory?.length > 0 ? (
                <Grid container spacing={2}>
                  {maintenanceHistory?.map((maintenance) => (
                    <Grid item xs={12} key={maintenance.id}>
                      <Card variant="outlined">
                        <CardHeader
                          title={maintenance.titulo}
                          subheader={
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                mt: 0.5,
                              }}
                            >
                              <CalendarTodayIcon
                                fontSize="small"
                                color="action"
                              />
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {maintenance.fecha_realizado}
                              </Typography>
                            </Box>
                          }
                          action={
                            <Box sx={{ display: "flex", gap: 1 }}>
                          
                              {renderMaintenanceStatusChip(maintenance.realizado)}
                            </Box>
                          }
                        />
                        <CardContent>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            gutterBottom
                          >
                            {maintenance.tarea}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                              mt: 1,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <PersonIcon fontSize="small" color="action" />
                              <Typography variant="body2">
                                Técnico: {maintenance.ejecuto}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <AssignmentIcon fontSize="small" color="action" />
                              <Typography variant="body2">
                                Orden: {maintenance.ot_nro ? maintenance.ot_nro : "N/A" }
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <InfoIcon fontSize="small" color="action" />
                              <Typography variant="body2">
                                Duración: {maintenance.hrshombre} | Costo:{" "}
                                {maintenance.costo_materiales}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <DescriptionIcon fontSize="small" color="action" />
                              <Typography variant="body2">
                                Descripcion: {maintenance.descripcion}
                              </Typography>
                            </Box>
                          </Box>

                         {/*  {maintenance.parts.length > 0 && (
                            <Box sx={{ mt: 2 }}>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                gutterBottom
                              >
                                Repuestos utilizados:
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {maintenance.parts.map((part, index) => (
                                  <Chip
                                    key={index}
                                    label={part}
                                    size="small"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            </Box>
                          )} */}
                        </CardContent>
                     
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography
                  variant="body1"
                  color="text.secondary"
                  align="center"
                  sx={{ py: 4 }}
                >
                  No hay registros de mantenimiento para este equipo
                </Typography>
              )}
            </Box>
          )}

          {/* Tab de Órdenes de Trabajo */}
          {tabValue === 1 && (
            <Box sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Órdenes de Trabajo
              </Typography>

              {workOrdersHistory?.length > 0 ? (
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>OT Nro</TableCell>
                        <TableCell>Tarea</TableCell>
                        <TableCell>Fecha</TableCell>
                        <TableCell>Vencimiento</TableCell>
                        <TableCell>Responsable</TableCell>
                        <TableCell>Estado</TableCell>
{/*                         <TableCell>Acciones</TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {workOrdersHistory?.map((order) => (
                        <TableRow key={order.id_orden}>
                          <TableCell>{order.id_orden}</TableCell>
                          <TableCell>{order.nombre_tarea}</TableCell>
                          <TableCell>{moment(order.fecha_orden).format("DD/MM/YYYY")}</TableCell>
                          <TableCell>{moment(order.vencimiento).format("DD/MM/YYYY")}</TableCell>
                          <TableCell>{order.responsable_tarea}</TableCell>
                          <TableCell>
                            {renderOrderStatusChip(order.estado)}
                          </TableCell>
                        
                         {/*  <TableCell>
                            <IconButton size="small" color="primary">
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography
                  variant="body1"
                  color="text.secondary"
                  align="center"
                  sx={{ py: 4 }}
                >
                  No hay órdenes de trabajo para este equipo
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      {/*   <Button startIcon={<PrintIcon />} variant="outlined">
          Imprimir Historial
        </Button> */}
      </DialogActions>

      {/* Diálogo de detalles de mantenimiento */}
      <Dialog
        open={detailDialogOpen}
        onClose={handleCloseDetail}
        maxWidth="md"
        fullWidth
      >
        {selectedMaintenance && (
          <>
            <DialogTitle>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="h6">Detalles del Mantenimiento</Typography>
                <IconButton onClick={handleCloseDetail} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography variant="h5">
                      {selectedMaintenance.title}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      {renderMaintenanceTypeChip(selectedMaintenance.type)}
                      {renderMaintenanceStatusChip(selectedMaintenance.status)}
                    </Box>
                  </Box>
                  <Divider sx={{ my: 2 }} />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Información General
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CalendarTodayIcon fontSize="small" color="action" />
                      <Typography variant="body2" color="text.secondary">
                        Fecha:
                      </Typography>
                      <Typography variant="body2">
                        {selectedMaintenance.date}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <PersonIcon fontSize="small" color="action" />
                      <Typography variant="body2" color="text.secondary">
                        Técnico:
                      </Typography>
                      <Typography variant="body2">
                        {selectedMaintenance.technician}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <AssignmentIcon fontSize="small" color="action" />
                      <Typography variant="body2" color="text.secondary">
                        Orden de Trabajo:
                      </Typography>
                      <Typography variant="body2">
                        {selectedMaintenance.workOrder}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <InfoIcon fontSize="small" color="action" />
                      <Typography variant="body2" color="text.secondary">
                        Duración:
                      </Typography>
                      <Typography variant="body2">
                        {selectedMaintenance.duration}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <InfoIcon fontSize="small" color="action" />
                      <Typography variant="body2" color="text.secondary">
                        Costo:
                      </Typography>
                      <Typography variant="body2">
                        {selectedMaintenance.cost}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Repuestos Utilizados
                  </Typography>
                  {selectedMaintenance.parts.length > 0 ? (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selectedMaintenance.parts.map((part, index) => (
                        <Chip key={index} label={part} size="small" />
                      ))}
                    </Box>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No se utilizaron repuestos
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Descripción
                  </Typography>
                  <Paper variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="body2">
                      {selectedMaintenance.description}
                    </Typography>
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Observaciones
                  </Typography>
                  <Paper variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="body2">
                      {selectedMaintenance.observations}
                    </Typography>
                  </Paper>
                </Grid>

                {selectedMaintenance.images.length > 0 && (
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      gutterBottom
                    >
                      Imágenes
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                      {selectedMaintenance.images.map((img, index) => (
                        <Paper
                          key={index}
                          variant="outlined"
                          sx={{
                            width: 120,
                            height: 120,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <ImageIcon color="action" sx={{ fontSize: 40 }} />
                        </Paper>
                      ))}
                    </Box>
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDetail}>Cerrar</Button>
              <Button startIcon={<PrintIcon />} variant="outlined">
                Imprimir
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Dialog>
  );
}
